module.exports = __webpack_public_path__ + "static/media/traycorp15.f33fba76.png";